import { FC, useState } from "react";

import { PortfolioItem } from "entities/portfolios";
import PhotoViewer from "modules/assets/AssetInfoTab/PhotoViewer";
import { DateHelper } from "utils/helpers";

import styles from "./style.module.scss";

type PropTypes = {
  portfolio: PortfolioItem | null;
};

const PortfolioInfoTab: FC<PropTypes> = ({ portfolio }) => {
  const [viewerIndex, setViewerIndex] = useState<number | null>(null);
  const images = portfolio?.images ?? [];

  const companyFields = [
    { label: "Company", value: portfolio?.company_name },
    {
      label: "Created",
      value: !!portfolio?.created_at ? DateHelper.toFormat(portfolio.created_at, "MMMM dd, yyyy") : "",
    },
  ];

  return (
    <div className={styles.info}>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Portfolio information</h2>

        <div className={styles.fields}>
          {companyFields.map((field) => (
            <div key={field.label} className={styles.field}>
              <span className={styles.fieldLabel}>{field.label}</span>
              <span className={styles.fieldValue}>{field.value}</span>
            </div>
          ))}
        </div>

        <div className={styles.details}>
          <div className={styles.box}>
            <span className={styles.boxLabel}>Portfolio manager</span>

            <div className={styles.manager}>
              <span className={styles.avatar}>{portfolio?.manager?.full_name?.charAt(0)}</span>

              <div className={styles.managerInfo}>
                <div className={styles.managerName}>
                  <span className={styles.name}>{portfolio?.manager?.full_name}</span>
                  <span className={styles.position}>{portfolio?.manager?.position ?? "-"}</span>
                </div>

                <div className={styles.managerContacts}>
                  <span className={styles.contact}>{portfolio?.manager?.email}</span>
                  <span className={styles.contact}>{portfolio?.manager?.phone}</span>
                </div>
              </div>
            </div>
          </div>

          {portfolio?.description && (
            <div className={styles.box}>
              <span className={styles.boxLabel}>Description</span>
              <span className={styles.description}>{portfolio?.description}</span>
            </div>
          )}
        </div>
      </section>

      {!!images?.length && (
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Photo</h2>

          <div className={styles.photos}>
            {images.map((image, index) => (
              <button key={image.id} type="button" className={styles.photo} onClick={() => setViewerIndex(index)}>
                <img src={image.url} alt={image.original_name} />
              </button>
            ))}
          </div>
        </section>
      )}

      {viewerIndex !== null && (
        <PhotoViewer images={images} startIndex={viewerIndex} onClose={() => setViewerIndex(null)} />
      )}
    </div>
  );
};

export default PortfolioInfoTab;
